import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const SelectTipoAcaoFiscal = ({ formik, field, disabled }) => {
  const [tipoAcao, setTipoAcao] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    request(apiRoutes.fiscalizacao.parametrizacao.consultaTipoAcao);
  }, [request]);

  useEffect(() => {
    if (data) setTipoAcao(data.result);

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &nbsp;Carregando ...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={disabled}
            value={formik.values[field]}
            onChange={(e) => {
              const index = e.nativeEvent.target.selectedIndex;
              formik.setFieldValue("descricaoTipoAcaoFiscal", e.target[index].innerText);
              formik.setFieldValue(field, e.target.value);
            }}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            <option key="0" value="">
              Selecione
            </option>
            {tipoAcao.map((item) => (
              <option key={item.sequenceTipoAcaoFiscal} value={item.sequenceTipoAcaoFiscal}>
                {item.descricaoTipoAcaoFiscal}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectTipoAcaoFiscal;
